import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=55c120fa&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=55c120fa&prod&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=55c120fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c120fa",
  null
  
)

export default component.exports